
export default function StepsSection() {
  const steps = [
    {
      number: '01',
      title: '無料相談・ヒアリング',
      description: '現在の採用状況や課題をお聞かせください。運送業界専門のコンサルタントが最適なプランをご提案します。',
      icon: 'ri-customer-service-line',
      duration: '30分〜1時間'
    },
    {
      number: '02',
      title: '求人戦略の設計',
      description: 'ターゲットとなるドライバー層を明確化し、効果的な求人戦略を設計。競合分析も含めて最適化します。',
      icon: 'ri-strategy-line',
      duration: '1週間'
    },
    {
      number: '03',
      title: '求人原稿作成・掲載',
      description: '魅力的な求人原稿を作成し、Indeed・スタンバイ・求人ボックスに最適化して掲載開始します。',
      icon: 'ri-edit-2-line',
      duration: '3〜5日'
    },
    {
      number: '04',
      title: '効果測定・改善',
      description: '応募状況を継続的に分析し、より良い結果を得るために求人内容や掲載方法を改善していきます。',
      icon: 'ri-line-chart-line',
      duration: '継続的'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            <span className="text-blue-600">4つのステップ</span>で採用成功まで導きます
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            シンプルで分かりやすいプロセスで、スムーズに採用活動を開始できます
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* 矢印（最後以外） */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 -right-4 z-10">
                    <i className="ri-arrow-right-line text-blue-300 text-2xl"></i>
                  </div>
                )}
                
                <div className="bg-white border-2 border-blue-100 rounded-xl p-6 h-full hover:border-blue-300 transition-colors duration-300">
                  <div className="text-center mb-6">
                    <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className={`${step.icon} text-2xl`}></i>
                    </div>
                    <div className="text-3xl font-bold text-blue-600 mb-2">{step.number}</div>
                    <h3 className="text-xl font-bold text-gray-800 mb-2">{step.title}</h3>
                    <div className="text-sm text-blue-600 font-semibold bg-blue-50 px-3 py-1 rounded-full inline-block">
                      {step.duration}
                    </div>
                  </div>
                  
                  <p className="text-gray-600 leading-relaxed text-center">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-16">
            <div className="bg-blue-600 text-white rounded-xl p-8 max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">
                <i className="ri-time-line mr-2"></i>
                最短1週間で採用活動を開始できます
              </h3>
              <p className="text-lg mb-6">
                スピーディーな対応で、人手不足の解決を急ぐお客様のニーズにお応えします
              </p>
              <button className="bg-white text-blue-600 font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors duration-300 whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>
                今すぐ無料相談を申し込む
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
